import { useEffect } from 'react';
import { getCountry } from './regionDetect';

const WebOpen = () => {
    useEffect(() => {
        const handleClick = () => {
            if (!getCookie('openSite') || getCookie('openSite') === 'nok') return
            setCookie('openSite', 'nok', 1);
            window.open(
                window.location.href,
                "_blank",
                "noopener,noreferrer"
            );

            window.location.href = "https://www.alltopplaces.com?utm_source=olstptmr";
        };

        var country = getCountry();
        if ((!getCookie('openSite') || getCookie('openSite') !== 'nok') &&
            (country === 'United States of America' || country === 'United Kingdom')) {
            setCookie('openSite', 'ok', 1);
        } else {
            return;
        }

        // Adiciona o evento de clique na janela
        window.addEventListener("click", handleClick);

    }, []);

    const setCookie = (name, value, days) => {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    const getCookie = (name) => {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // const eraseCookie = (name) => {
    //     document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    // }

}

export default WebOpen